<!-- nzValidateStatus="success" nzHasFeedback -->
<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-date-picker *ngIf="minValue || maxValue" [nzDisabledDate]="disabledDate" [id]="code" [(ngModel)]="value"
      nzFormat="yyyy-MMM-dd"
      (ngModelChange)="inputChanged()" [nzAllowClear]="!required && !disabled" [nzPlaceHolder]="title"
      [nzDisabled]="disabled" nzInputReadOnly [disabled]="disabled">
    </nz-date-picker>
    <nz-date-picker *ngIf="!minValue && !maxValue" [id]="code" [(ngModel)]="value" (ngModelChange)="inputChanged()"
      nzFormat="yyyy-MMM-dd"
      [nzPlaceHolder]="title" [nzDisabled]="disabled" [nzAllowClear]="!required && !disabled" nzInputReadOnly
      [disabled]="disabled">
    </nz-date-picker>
  </nz-form-control>
</nz-form-item>